import { Injectable } from '@angular/core';
import { AspectRationFormatTree } from '@thehubz/client/core';

@Injectable({
  providedIn: 'root'
})
export class StepperDialogArrayUtilService {
  /**
   * Flattens a nested array
   * @param members
   * @returns
   */
  flatNestedArray = (members: AspectRationFormatTree[]): AspectRationFormatTree[] => {
    let children: AspectRationFormatTree[] = [];
    return members
      .map((m) => {
        if (m.children && m.children.length) {
          children = [...children, ...m.children];
        }
        return m;
      })
      .concat(children.length ? this.flatNestedArray(children) : children);
  };

  /**
   * Transform 2 level array
   * @param arr
   * @returns
   */
  transform2LvlArray(arr: AspectRationFormatTree[]) {
    return arr.reduce(function (r: Record<string, AspectRationFormatTree[]>, a) {
      r[a?.parent?.parent?.id || ''] = r[a?.parent?.parent?.id || ''] || [];
      r[a?.parent?.parent?.id || ''].push(a);
      return r;
    }, Object.create(null));
  }

  /**
   * Transform 1 level array
   * @param arr
   * @returns
   */
  transform1LvlArray(arr: AspectRationFormatTree[]) {
    return arr.reduce(function (r: Record<string, AspectRationFormatTree[]>, a) {
      r[a?.parent?.id || ''] = r[a?.parent?.id || ''] || [];
      r[a?.parent?.id || ''].push(a);
      return r;
    }, Object.create(null));
  }
}
